
export default {
  routeImporter: {
    loadRouteFile: 'Import file',
    failedToLoadFile: 'Failed to load file selected. Make sure the file is not corrupted and in one of the accepted formats',
    acceptedImportTypes: 'Accepted import types',
    dictDefaultMessage: 'Drop a route file to import or click here',
    dictFallbackMessage: 'Browser not supported',
    dictFileTooBig: 'File too big',
    dictInvalidFileType: 'Invalid file type',
    dictCancelUpload: 'Cancel upload',
    dictUploadCanceled: 'Upload Canceled',
    dictRemoveFile: 'Remove file'
  }
}
